






















































































































































































































































































































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { nonnegativeInteger, nonnegativeInteger0, positiveInteger, postivePrice } from '@root/utils/validators';
import { createCoupon, appendCoupon, businessListByParkId, listByOrgdepId } from '@/api/discount-management/index';
import Utils from '@root/utils/common';
import { couponTypeMap } from '@/types/discount-management/dictionaries';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import OrganizationSearch from '../../../../components/organization-search/index.vue';
import ModalConfig from '@/components/modal-config/index.vue';
import moment from 'moment';
import * as _ from 'lodash';
import { MessageOptions } from 'ant-design-vue/types/message';
export interface IForm {
  orgDepId: string;
  merchantId: string; //商户Id
  type: string; // 优惠券类型：01 时长优惠 02金额优惠 03 全免优惠 04折扣优惠 05时段优惠 （折扣暂时不做）
  parkId: string; // 车场id
  name: string; // 优惠券名称
  value: string; // 优惠数额：根据类型表示不同的值：01时长券，单位为分钟；02 表示金额券，单位为分；03、05为非必填项
  totalNum: string; //总数量
  dayLimitNum: string; //每日发送上限数量
  singleReceiveLimitNum: string; // 单次停车发放上限数
  effectiveDate: any; //有效期 yyyy-MM-dd
  advanceSaleStatus: string; //预售状态：00 否 01 是
  settlementPrice: string; //结算单价 单位 ：元  预售状态为01时必填
  settlementTotalPrice: string; //结算总价 单位： 元  预售状态为01时必填
  merchantType: string;
  effectiveBeginDate: any; //有效期 yyyy-MM-dd
}
@Component({
  name: 'AddEditModal',
  components: { ParkingLotSearch, ModalConfig, OrganizationSearch }
})
export default class AddEditModal extends Vue {
  // 是否编辑状态
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  // 是否显示机构
  @Prop({ type: Boolean, default: false })
  showFlag!: boolean;
  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  // 编辑状态回填数据
  @Prop()
  data!: any;
  form: any = null;
  // options = _.filter(
  //   Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type),
  //   function(o) {
  //     return o.value != '04';
  //   }
  // );
  // options = Utils.toLabelVal(couponTypeMap)
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type);
  businessTypeOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_merc_type);
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };
  id = '';
  confirmLoading: boolean = false;
  couponOptions = [];
  typeId = '02'; //优惠券类型
  statusId = '00'; //预发售状态
  merchantName = '';
  parkName = '';
  validatorsDay = nonnegativeInteger; //每日发放校验
  validatorsingleReceive = nonnegativeInteger; //单日领取上限校验
  validatorsValue = nonnegativeInteger0; //优惠数额校验
  validatorTotalNum = positiveInteger; //总张数校验
  validatorPrice = postivePrice;
  private moment = moment;
  endOpen = false;
  disabledStartDate(startValue: any) {
    const endValue = this.form.getFieldValue('effectiveDate');
    if (!startValue || !endValue) {
      return startValue && startValue < moment().subtract(1, 'days');
    }
    return (startValue && startValue < moment().subtract(1, 'days')) || startValue.valueOf() >= endValue.valueOf();
  }
  disabledEndDate(endValue: any) {
    const startValue = this.form.getFieldValue('effectiveBeginDate');
    if (!endValue || !startValue) {
      return endValue && endValue < moment().subtract(1, 'days');
    }
    return startValue.valueOf() >= endValue.valueOf();
  }
  handleStartOpenChange(open: any) {
    if (!open) {
      this.endOpen = true;
    }
  }
  handleEndOpenChange(open: boolean) {
    this.endOpen = open;
  }

  //不可选择的日期
  disabledDate(current: any) {
    return current && current < moment().subtract(1, 'days');
  }
  //form初始化
  init() {
    this.couponOptions = [];
    if (this.isEdit && this.data) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const {
            id,
            type,
            name,
            value,
            parkName,
            merchantName,
            totalNum,
            singleReceiveLimitNum,
            effectiveDate,
            advanceSaleStatus,
            settlementPrice,
            settlementTotalPrice,
            dayLimitNum,
            orgDepId,
            merchantType,
            effectiveBeginDate
          } = this.data;
          this.id = id;
          this.parkName = parkName;
          this.merchantName = merchantName;
          this.typeId = type;
          this.statusId = advanceSaleStatus;
          console.log(effectiveDate);
          return {
            merchantType: this.$form.createFormField({
              value: merchantType
            }),
            orgDepId: this.$form.createFormField({
              value: orgDepId
            }),
            type: this.$form.createFormField({
              value: type
            }),
            name: this.$form.createFormField({
              value: name
            }),
            value: this.$form.createFormField({
              value: Number(value)
            }),
            totalNum: this.$form.createFormField({
              value: totalNum
            }),
            singleReceiveLimitNum: this.$form.createFormField({
              value: singleReceiveLimitNum
            }),
            dayLimitNum: this.$form.createFormField({
              value: dayLimitNum
            }),
            effectiveDate: this.$form.createFormField({
              value: effectiveDate ? this.moment(effectiveDate, 'YYYY-MM-DD') : null
            }),
            effectiveBeginDate: this.$form.createFormField({
              value: effectiveBeginDate ? this.moment(effectiveBeginDate, 'YYYY-MM-DD') : null
            }),
            advanceSaleStatus: this.$form.createFormField({
              value: advanceSaleStatus
            }),
            settlementPrice: this.$form.createFormField({
              value: advanceSaleStatus == '00' ? '' : settlementPrice
            }),
            settlementTotalPrice: this.$form.createFormField({
              value: advanceSaleStatus == '00' ? '' : settlementTotalPrice
            })
          };
        }
      });
    } else {
      this.id = '';
      this.parkName = '';
      this.merchantName = '';
      this.typeId = '02';
      this.statusId = '00';
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            type: this.$form.createFormField({
              value: '02'
            }),
            advanceSaleStatus: this.$form.createFormField({
              value: '00'
            })
          };
        }
      });
    }
  }
  //提交表单
  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        const totalNum = Number(this.form.getFieldValue('totalNum'));
        const dayLimitNum = Number(this.form.getFieldValue('dayLimitNum'));
        const singleReceiveLimitNum = Number(this.form.getFieldValue('singleReceiveLimitNum'));
        if (dayLimitNum != 0 && totalNum < dayLimitNum) return this.$message.error('每日发放上限不应该超过总张数');
        if (singleReceiveLimitNum != 0 && totalNum < singleReceiveLimitNum)
          return this.$message.error('单次停车发放上限不应该超过总张数');
        if (values['effectiveDate']) {
          const now = new Date(Utils.getFormatTime(new Date(), 'yyyy-MM-DD')).getTime();
          const effectiveDay = new Date(values['effectiveDate'].format('YYYY-MM-DD')).getTime();
          if (effectiveDay < now) return this.$message.error('发放有效期应不小于当前时间');
        }
        if (values['effectiveBeginDate']) {
          const now = new Date(Utils.getFormatTime(new Date(), 'yyyy-MM-DD')).getTime();
          const effectiveDay = new Date(values['effectiveBeginDate'].format('YYYY-MM-DD')).getTime();
          if (effectiveDay < now) return this.$message.error('发放有效期应不小于当前时间');
        }
        this.onAddOrEdit(values);
      } else {
        console.log('错误', err);
      }
    });
  }
  //新增保存表单
  async onAddOrEdit(values: IForm) {
    if (this.confirmLoading) return;
    this.confirmLoading = true;
    if (values.type === '03') {
      values.value = '0';
    }
    if (values.type === '05') {
      values.value = '1';
    }
    try {
      const json = {
        ...values,
        effectiveDate: values['effectiveDate'] ? values['effectiveDate'].format('YYYY-MM-DD') : '',
        effectiveBeginDate: values['effectiveBeginDate'] ? values['effectiveBeginDate'].format('YYYY-MM-DD') : ''
      };
      if (this.isEdit) {
        const jsonData = {
          id: this.id,
          totalNum: values['totalNum'],
          dayLimitNum: values['dayLimitNum'],
          singleReceiveLimitNum: values['singleReceiveLimitNum'],
          effectiveDate: values['effectiveDate'] ? values['effectiveDate'].format('YYYY-MM-DD') : '',
          effectiveBeginDate: values['effectiveBeginDate'] ? values['effectiveBeginDate'].format('YYYY-MM-DD') : '',
          advanceSaleStatus: values['advanceSaleStatus'],
          settlementPrice: values['settlementPrice'],
          settlementTotalPrice: values['settlementTotalPrice']
        };
        const { status, msg } = await appendCoupon(jsonData);
        this.successTip(status, msg);
      } else {
        const { status, msg } = await createCoupon(json);
        this.successTip(status, msg);
      }
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || `${this.isEdit ? '追加' : '新增'}失败`);
    } finally {
      this.confirmLoading = false;
    }
  }
  //成功提示
  successTip(status: string | number, msg: any) {
    if (status === '9999') {
      this.$message.success(`${this.isEdit ? '追加' : '新增'}成功`);
      this.form.resetFields();
      this.$emit('create');
      // this.showFlag = false
      this.$emit('changeShowFlag', false);
    } else {
      this.$message.error(msg ? msg : `${this.isEdit ? '追加' : '新增'}失败`);
    }
  }
  //切换车场
  async changePark(val: any) {
    const { data } = await businessListByParkId({ parkId: val });
    this.couponOptions = data;
    this.form.setFieldsValue({
      merchantId: ''
    });
  }
  //切换机构
  async changeorgDep(val: any) {
    const { data } = await listByOrgdepId({ orgdepId: val });
    this.couponOptions = data;
    this.form.setFieldsValue({
      merchantId: ''
    });
  }
  //切换类型
  changeType(val: any) {
    console.log(val);
    this.typeId = val;
    if (val != '01' && val != '02' && val != '04') {
      this.form.setFieldsValue({
        value: '1'
      });
    } else {
      this.form.setFieldsValue({
        value: ''
      });
    }
  }
  //切换状态
  changeStatus(val: any) {
    const { target } = val;
    this.statusId = target.value;
    // let allPrice = this.form.getFieldValue('settlementTotalPrice')
    // let price = this.form.getFieldValue('settlementPrice')
    // this.form.setFieldsValue({ settlementTotalPrice: allPrice, settlementPrice: price })
  }
  Mul(arg1: { toString: () => any }, arg2: { toString: () => any }) {
    var r1 = arg1.toString(),
      r2 = arg2.toString(),
      m,
      resultVal,
      d = arguments[2];
    m = (r1.split('.')[1] ? r1.split('.')[1].length : 0) + (r2.split('.')[1] ? r2.split('.')[1].length : 0);
    resultVal = (Number(r1.replace('.', '')) * Number(r2.replace('.', ''))) / Math.pow(10, m);
    // @ts-ignore hack
    return typeof d !== 'number' ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)));
  }
  //失去焦点时计算总价
  blurInput() {
    if (this.statusId != '00') {
      const number = this.form.getFieldValue('totalNum');
      const allPrice = this.form.getFieldValue('settlementTotalPrice');
      const price = this.form.getFieldValue('settlementPrice');
      if (number && price) {
        const numberReg = /^[1-9]\d*$/;
        const priceReg = /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/;
        if (numberReg.test(number) && priceReg.test(price)) {
          this.form.setFieldsValue({
            settlementTotalPrice: String(this.Mul(price, number))
          });
        }
      }
    }
  }
  //张数发生变化时
  changeNmuber() {
    this.blurInput();
  }
  //单价发生变化时
  changeItemPrice() {
    this.blurInput();
  }
  //总价发生变化时
  changeAllPrice(val: any) {
    const number = this.form.getFieldValue('totalNum');
    const allPrice = this.form.getFieldValue('settlementTotalPrice');
    const price = this.form.getFieldValue('settlementPrice');
    if (allPrice && number && number != 0) {
      const numberReg = /^[1-9]\d*$/;
      const priceReg = /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/;
      if (numberReg.test(number) && priceReg.test(allPrice))
        this.form.setFieldsValue({
          settlementPrice: String((Number(allPrice) / Number(number)).toFixed(2))
        });
    }
  }
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  mounted() {
    this.init();
  }
  // showFlag = false
  typeChange(e: string) {
    console.log(e, '-------------0000000000');
    if (e === '04') {
      // this.showFlag = true
      this.$emit('changeShowFlag', true);
    } else {
      // this.showFlag = false
      this.$emit('changeShowFlag', false);
    }
  }
  filterOptionT(input: string, option: { componentOptions: { children: { text: string }[] } }) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
}
